import { Dialog } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { ModalDialog } from '@sistemiv/s-components'
import { DispatchSetAction } from '@sistemiv/s-components/dist/esm/types/types'
import React, { FC, useEffect, useState } from 'react'

const PrivacyPolicyModal: FC<{
  open: boolean
  setOpen: DispatchSetAction<boolean>
}> = ({ open, setOpen }) => {
  const [content, setContent] = useState('')

  useEffect(() => {
    if (open) {
      fetch('/privacy-policy.html')
        .then((res) => res.text())
        .then(setContent)
    }
  }, [open])

  return (
    <ModalDialog isOpen={open} setOpen={setOpen} className='!max-w-3xl !overflow-auto !max-h-screen'>
      <Dialog.Title as='h3' className='leading-6 text-lg flex items-center justify-end'>
        <button onClick={() => setOpen(false)} className='rounded-full p-2 hover:bg-gray-100 active:text-blue-500'>
          <XMarkIcon className='w-5 h-5 stroke-gray-500 active:stroke-blue-500' />
        </button>
      </Dialog.Title>

      <div className='pt-5 space-y-6'>
        <div
          className='prose max-h-[80vh] overflow-y-auto [&_table]:hidden'
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </ModalDialog>
  )
}

export default PrivacyPolicyModal
